import React from 'react';
import classNames from 'classnames';
/**
 * Bronson ButtonContainer object (component).
 * @constructor
 */
export function ButtonContainer({ children, className, testId, center, left, right, stretch, nav, vertical, noWrap, wrapReverse, reverse, leftSmall, centerSmall, rightSmall, verticalSmall, reverseSmall, ...otherProps }) {
    const divClassNameList = classNames({
        'o-button-container ': true,
        // main class modifier convenience prop extension
        'o-button-container--center ': center, // Convenience prop
        'o-button-container--left ': left, // Convenience prop
        'o-button-container--right ': right, // Convenience prop
        'o-button-container--nav ': nav, // Convenience prop
        'o-button-container--stretch ': stretch, // Convenience prop
        'o-button-container--vertical ': vertical, // Convenience prop
        'o-button-container--nowrap ': noWrap, // Convenience prop
        'o-button-container--wrap-reverse ': wrapReverse, // Convenience prop
        'o-button-container--reverse ': reverse, // Convenience prop
        /**
         * `o-button-container--center-wrap` was replaced in Bronson.
         * @see https://jira.io.platform.vwfs.io/browse/BRON-5562
         */
        'o-button-container--left@s ': leftSmall, // Convenience prop
        'o-button-container--center@s ': centerSmall, // Convenience prop
        'o-button-container--right@s ': rightSmall, // Convenience prop
        'o-button-container--vertical@s ': verticalSmall, // Convenience prop
        'o-button-container--reverse@s ': reverseSmall, // Convenience prop
    }, className).trim();
    function renderChildren() {
        return React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) {
                return null;
            }
            const buttonClassName = `o-button-container__button ${child.props.className ? child.props.className : ''}`;
            return React.cloneElement(child, { className: buttonClassName });
        });
    }
    return (React.createElement("div", { ...otherProps, "data-testid": testId, className: divClassNameList }, renderChildren()));
}
